<template>
<div></div>
</template>

<script>
export default {
  name: "question"
}
</script>

<style scoped>

</style>